export var getStyles = function (props) {
    return ({
        root: [
            'ms-Persona',
            {}
        ],
    });
};
//# sourceMappingURL=Persona.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/Persona/Persona.styles.js
// module id = 669
// module chunks = 0